import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common';
import { getCurrentLanguage } from '../core/helpers/utils';
import { generalTranslations } from '../core/helpers/translations';

// constants
import { EventType } from 'src/app/core/constants/events';

// service
import { EventService } from 'src/app/core/service/event.service';
import { ArbitrosService } from './arbitros.service';
import { AuthenticationService } from '../core/service/auth.service';

import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

// Para el datepicker
import { NgbDateStruct, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';

import { Arbitro } from './arbitros.model';

// Para el selector de países múltiple
import { Select2Data } from 'ng-select2-component';

// Para cabiar el título de la tab
import { Title } from '@angular/platform-browser';

import { fillAndDownloadPDF } from '../core/helpers/pdfexport';
import { FormControl } from '@angular/forms';
import { NotificationsService } from '../core/service/notifications.service';



@Component({
  selector: 'app-detail-arbitro',
  templateUrl: './detail-arbitro.component.html',
  styleUrls: ['./detail-arbitro.component.scss']
})
export class DetailArbitroComponent implements OnInit {

  constructor(private fb: FormBuilder,
    private eventService: EventService,
    private arbitrosService: ArbitrosService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private authService: AuthenticationService,
    private notificationService: NotificationsService,
    private titleService: Title) { }

  // Selectores 
  nacionalidades: Select2Data = [];
  colegiaciones: Select2Data = [];
  profesiones: Select2Data = [];
  idiomas: Select2Data = [];
  sectores: Select2Data = [];
  sistemasJuridicos: Select2Data = [];

  activeWizard1: number = 1;

  basicWizardForm!: FormGroup;

  emailControl: FormControl = new FormControl('');

  // Date Picket
  model1!: NgbDateStruct;

  // Control de loading de la tabla cuando los usuarios hayan sido recibidos desde el backend
  loaded: boolean = false;

  // Control de errores
  error: string = '';

  // Mensaje final de éxito
  finalSaveMessage: boolean = false;

  // Define el número de pestañas max que hay en el form
  maxtab: number = 3;

  // nivel_acceso 
  adminView: boolean = false

  // Tabla experiencia en FORMACION
  matriz: any[][] = [];

  currentLanguage: string = getCurrentLanguage();

  experienciaFilas = [''];
  experienciaFilasCategoria = ['']

  experienciaFilasES = ['CIIAM', 'Otra institución', 'Ad Hoc', 'Institucional', 'Ad Hoc'];
  experienciaFilasCategoriaES = ['Arbitraje internacional', '', '', 'Arbitraje nacional', ''];

  experienciaFilasEN = ['CIIAM', 'Other institution', 'Ad Hoc', 'Institutional', 'Ad Hoc'];
  experienciaFilasCategoriaEN = ['International Arbitration', '', '', 'National Arbitration', ''];

  experienciaFilasCategoriaFormGroup = ['internacional', 'internacional', 'internacional', 'nacional', 'nacional'];
  experienciaFilasFormGroup = ['ciam', 'otra', 'adhoc', 'institucional', 'adhoc']
  experienciaColumnFormGroup = ['presidente', 'arbitro_unico', 'coarbitro', 'letrado', 'secretario', 'arbitro_emergencia'];
  experienciaFilaFormGroup = ['ciam', 'otra', 'internacional_adhoc', 'institucional', 'nacional_adhoc']

  totalesFila: { label: string, value: number }[] = []
  totalesColumna: { label: string, value: number }[] = []

  // Campos multiselect
  nacionalidadesArray: string[] = [];
  profesionesArray: string[] = [];
  colegiacionesArray: string[] = [];
  idiomasArray: string[] = [];
  sectoresArray: string[] = [];
  sistemasJuridicosArray: string[] = [];

  // Indicador de guardado
  isSaving: boolean = false;

  // Variable para controlar la inicialización del formulario y no lanzar updates cuando se rellenan todos los valores por primera vez
  formInitialized = false;
  // Variable para almacenar el temporizador de guardado
  saveTimer: any;

  // Evita el autosave durante recargas programaticas
  isReloading: boolean = false;
  // Snapshot para detectar cambios reales
  lastSavedFormValue: string = '';
  // Evita guardados duplicados en paralelo
  saveInFlight: Promise<void> | null = null;

  // Avatar con url sergura
  avatarUrl?: SafeUrl;
  avatarObjectUrl?: string;

  // Datos completos de árbitro
  datosCompletos?: boolean = false;

  // Gestión del email por separado
  emailTemporal: string = '';


  /**
  * Genera el FormGroupName
  */
  getFormControlName(experienciaFilasCategoria: string, experienciaFilas: string, j: any) {
    return "exp_" + experienciaFilasCategoria + "_" + experienciaFilas + "_" + j
  }

  _fetchData(id: string): void {

    forkJoin({
      resArbitro: this.arbitrosService.getArbitro(id),
      resNacionalidades: this.arbitrosService.getNacionalidades(),
      resColegiaciones: this.arbitrosService.getColegiaciones(),
      resProfesiones: this.arbitrosService.getProfesiones(),
      resIdiomas: this.arbitrosService.getIdiomas(),
      resSectores: this.arbitrosService.getSectores(),
      resSistemasJuridicos: this.arbitrosService.getSistemasJuridicos()
    }).subscribe({
      next: ({ resArbitro, resNacionalidades, resColegiaciones, resIdiomas, resProfesiones, resSectores, resSistemasJuridicos }) => {
        //console.log("Arbitro-> ", resArbitro);

        this.isReloading = true;
        this.formInitialized = false;

        // Idioma de la tabla experiencia
        if (this.currentLanguage === 'en') {
          this.experienciaFilas = this.experienciaFilasEN;
          this.experienciaFilasCategoria = this.experienciaFilasCategoriaEN;
        } else {
          this.experienciaFilas = this.experienciaFilasES;
          this.experienciaFilasCategoria = this.experienciaFilasCategoriaES;
        }

        // Arbitro con datos completos?
        this.datosCompletos = resArbitro.datos_obligatorios_completados;


        if (resArbitro.id) {
          this.arbitrosService.getAvatar(resArbitro.id).subscribe(avatarBlob => {
            if (avatarBlob) {
              if (this.avatarObjectUrl) {
                URL.revokeObjectURL(this.avatarObjectUrl);
              }
              this.avatarObjectUrl = URL.createObjectURL(avatarBlob);
              this.avatarUrl = this.sanitizer.bypassSecurityTrustUrl(this.avatarObjectUrl);
            }
          });
        }

        this.titleService.setTitle(`${resArbitro.nombre} ${resArbitro.apellidos}`);


        // Relleno el formulario con los datos sacados de la DB
        // Calculo la fila de totales
        this.calcularTotalesFila(resArbitro);

        // Calculo la columna de totales
        this.calcularTotalesColumna(resArbitro);

        // Procesamiento datos para Nacionalidades
        const dataNacionalidadesFromDB = resNacionalidades;
        const convertedNacionalidadesData = dataNacionalidadesFromDB.map(item => ({
          value: item.codigo_alfa2,
          label: item[this.currentLanguage]
        }));
        this.nacionalidades = convertedNacionalidadesData;

        // Procesamiento datos para colegiaciones
        const dataColegiacionesFromDB = resColegiaciones;
        const convertedColegiacionesData = dataColegiacionesFromDB.map(item => ({
          value: item.codigo_alfa2,
          label: item[this.currentLanguage] // Asumiendo que el campo se llama 'nombre'
        }));
        this.colegiaciones = convertedColegiacionesData;

        // Procesamiento datos para profesiones
        const dataProfesionesFromDB = resProfesiones;
        const convertedProfesionesData = dataProfesionesFromDB.map(item => ({
          value: item.nombre,
          label: item[this.currentLanguage] // Asumiendo que el campo se llama 'nombre'
        }));
        this.profesiones = convertedProfesionesData;

        // Procesamiento datos para idiomas
        const dataIdiomasFromDB = resIdiomas;
        const convertedIdiomasData = dataIdiomasFromDB.map(item => ({
          value: item.nombre,
          label: item[this.currentLanguage] // Asumiendo que el campo se llama 'nombre'
        }));
        this.idiomas = convertedIdiomasData;

        // Procesamiento datos para sectores
        const dataSectoresFromDB = resSectores;
        const convertedSectoresData = dataSectoresFromDB.map(item => ({
          value: item.nombre,
          label: item[this.currentLanguage] // Asumiendo que el campo se llama 'nombre'
        }));
        this.sectores = convertedSectoresData;

        // Procesamiento datos para sistemasJuridicos
        const dataSistemasJuridicosFromDB = resSistemasJuridicos;
        const convertedSistemasJuridicosData = dataSistemasJuridicosFromDB.map(item => ({
          value: item.nombre,
          label: item[this.currentLanguage] // Asumiendo que el campo se llama 'nombre'
        }));
        this.sistemasJuridicos = convertedSistemasJuridicosData;

        // Relleno el resto de datos del formulario con los formGroup una vez que tengo las nacionalidades ya obtenidas
        this.rellenarDatos(resArbitro);
        this.basicWizardForm.markAsPristine();
        this.lastSavedFormValue = JSON.stringify(this.basicWizardForm.value);

        // Cargo el componente cuando ya tengo todos los datos rellenos
        this.loaded = true;

        this.formInitialized = true;
        // Suscribirse a los cambios en el FormGroup después de que se han rellenado todos los datos

        this.isReloading = false;

      },
      error: (error) => {
        this.error = error;
        this.loaded = false;
        this.isReloading = false;
      }
    });

  }


  ngOnInit(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = generalTranslations[currentLanguage].TABLE;

    const id = this.route.snapshot.paramMap.get('id');

    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE, {
      title: "Editar Árbitro",
      breadCrumbItems: [{ label: currentTranslations.ARBITROS, path: '.' }, { label: currentTranslations.EDITAR_ARBITRO, path: '.', active: true }]
    });

    // Consulto el nivel de acceso del usuario que quiere acceder
    this.authService.currentUser().subscribe(user => {

      if (user?.nivel_acceso === "ADMIN")
        this.adminView = true;

      // Inicializo el formulario
      this.initializeForm();
      this.lastSavedFormValue = JSON.stringify(this.basicWizardForm.value);

      // Tabla experiencia    
      for (let i = 0; i < 5; i++) {
        this.matriz.push(Array(6).fill(''));
      }

      if (id !== null) {
        this._fetchData(id)
        // AUTOSAVE CADA 2s
        this.basicWizardForm.valueChanges.subscribe(() => {
          if (this.formInitialized && !this.isReloading && this.hasUnsavedChanges()) {
            clearTimeout(this.saveTimer);
            this.saveTimer = setTimeout(() => {
              if (!this.saveInFlight && this.hasUnsavedChanges()) {
                this.guardarDatosDelayed(id);
              }
            }, 2000); // Asumiendo que guardarDatosDelayed es un método en la clase
          }
        });
      }

      if (user?.nivel_acceso === "ADMIN") {
        this.maxtab = 4;
      }
      else {
        this.maxtab = 3;
      }


    });

  }


  valorOcero(valor: any): any {
    if (!valor)
      return 0;
    else
      return valor
  }

  // Función de autoguardado
  guardarDatosDelayed = (id: string): Promise<void> => {
    if (!this.hasUnsavedChanges()) {
      return Promise.resolve();
    }
    if (this.saveInFlight) {
      return this.saveInFlight;
    }
    this.saveInFlight = new Promise<void>((resolve, reject) => {
      // Lógica para guardar los datos aquí
      //this.isSaving = true;      

      // Obtener los valores del formulario
      const formData = this.basicWizardForm.value;
      //console.log("formData", formData)



      // Construir el objeto Arbitro
      const arbitro: Arbitro = {
        nombre: formData.datos.nombre,
        apellidos: formData.datos.apellidos,
        genero: formData.datos.genero,
        fecha_nacimiento: formData.datos.fecha_nacimiento,
        titulo: formData.datos.titulo,
        institucion: formData.datos.institucion,
        cargo: formData.datos.cargo,
        direccion: formData.datos.direccion,
        telefono: formData.datos.telefono,
        movil: formData.datos.movil,
        //email: formData.datos.email,
        nacionalidades: formData.datos.nacionalidades,
        es_representante: formData.datos.es_representante,
        profesiones: formData.datos.profesiones,
        profesion_otras: formData.datos.profesion_otras,

        titulos_academicos: formData.formacion.titulos_academicos,
        experiencia_profesional: formData.formacion.experiencia_profesional,
        colegiaciones: formData.formacion.colegiaciones,
        idiomas: formData.formacion.idiomas,
        idiomas_otros: formData.formacion.idiomas_otros,
        sectores: formData.formacion.sectores,
        sectores_otros: formData.formacion.sectores_otros,

        exp_internacional_ciam_presidente: this.valorOcero(formData.experiencia.exp_internacional_ciam_presidente),
        exp_internacional_otra_presidente: this.valorOcero(formData.experiencia.exp_internacional_otra_presidente),
        exp_internacional_adhoc_presidente: this.valorOcero(formData.experiencia.exp_internacional_adhoc_presidente),
        exp_nacional_institucional_presidente: this.valorOcero(formData.experiencia.exp_nacional_institucional_presidente),
        exp_nacional_adhoc_presidente: this.valorOcero(formData.experiencia.exp_nacional_adhoc_presidente),
        exp_internacional_ciam_arbitro_unico: this.valorOcero(formData.experiencia.exp_internacional_ciam_arbitro_unico),
        exp_internacional_otra_arbitro_unico: this.valorOcero(formData.experiencia.exp_internacional_otra_arbitro_unico),
        exp_internacional_adhoc_arbitro_unico: this.valorOcero(formData.experiencia.exp_internacional_adhoc_arbitro_unico),
        exp_nacional_institucional_arbitro_unico: this.valorOcero(formData.experiencia.exp_nacional_institucional_arbitro_unico),
        exp_nacional_adhoc_arbitro_unico: this.valorOcero(formData.experiencia.exp_nacional_adhoc_arbitro_unico),
        exp_internacional_ciam_coarbitro: this.valorOcero(formData.experiencia.exp_internacional_ciam_coarbitro),
        exp_internacional_otra_coarbitro: this.valorOcero(formData.experiencia.exp_internacional_otra_coarbitro),
        exp_internacional_adhoc_coarbitro: this.valorOcero(formData.experiencia.exp_internacional_adhoc_coarbitro),
        exp_nacional_institucional_coarbitro: this.valorOcero(formData.experiencia.exp_nacional_institucional_coarbitro),
        exp_nacional_adhoc_coarbitro: this.valorOcero(formData.experiencia.exp_nacional_adhoc_coarbitro),
        exp_internacional_ciam_letrado: this.valorOcero(formData.experiencia.exp_internacional_ciam_letrado),
        exp_internacional_otra_letrado: this.valorOcero(formData.experiencia.exp_internacional_otra_letrado),
        exp_internacional_adhoc_letrado: this.valorOcero(formData.experiencia.exp_internacional_adhoc_letrado),
        exp_nacional_institucional_letrado: this.valorOcero(formData.experiencia.exp_nacional_institucional_letrado),
        exp_nacional_adhoc_letrado: this.valorOcero(formData.experiencia.exp_nacional_adhoc_letrado),
        exp_internacional_ciam_secretario: this.valorOcero(formData.experiencia.exp_internacional_ciam_secretario),
        exp_internacional_otra_secretario: this.valorOcero(formData.experiencia.exp_internacional_otra_secretario),
        exp_internacional_adhoc_secretario: this.valorOcero(formData.experiencia.exp_internacional_adhoc_secretario),
        exp_nacional_institucional_secretario: this.valorOcero(formData.experiencia.exp_nacional_institucional_secretario),
        exp_nacional_adhoc_secretario: this.valorOcero(formData.experiencia.exp_nacional_adhoc_secretario),
        exp_internacional_ciam_arbitro_emergencia: this.valorOcero(formData.experiencia.exp_internacional_ciam_arbitro_emergencia),
        exp_internacional_otra_arbitro_emergencia: this.valorOcero(formData.experiencia.exp_internacional_otra_arbitro_emergencia),
        exp_internacional_adhoc_arbitro_emergencia: this.valorOcero(formData.experiencia.exp_internacional_adhoc_arbitro_emergencia),
        exp_nacional_institucional_arbitro_emergencia: this.valorOcero(formData.experiencia.exp_nacional_institucional_arbitro_emergencia),
        exp_nacional_adhoc_arbitro_emergencia: this.valorOcero(formData.experiencia.exp_nacional_adhoc_arbitro_emergencia),
        experiencia_cumplimentada: this.valorOcero(formData.experiencia.experiencia_cumplimentada),
        sistemasJuridicos: formData.experiencia.sistemasJuridicos,
        sistema_juridico_otros: formData.experiencia.sistema_juridico_otros,
        comunicaciones_comerciales: formData.experiencia.comunicaciones_comerciales,
        ...(this.adminView && { comentarios_internos: formData.comentarios.comentarios_internos }),
      };

      // Puedes llamar a tus servicios o funciones de guardado aquí
      if (id !== null) {
        this.arbitrosService.updateArbitro(id, arbitro).subscribe({
          next: () => {
            //this.eventService.broadcast(EventType.UPDATE_NAME, { userId: id }); // Actualizo el nmbre en topnav
            //this.isSaving = false;
            this.mostrarMensajeGuardado()
            //console.log("Arbitro enviado al back-> ", arbitro);
            this.error = '';
            // Recalculo totales
            this.calcularTotalesColumna(arbitro);
            this.calcularTotalesFila(arbitro);
            this.lastSavedFormValue = JSON.stringify(this.basicWizardForm.value);
            this.basicWizardForm.markAsPristine();
            this.saveInFlight = null;
            resolve(); // Resuelve la promesa cuando el guardado es exitoso
          },
          error: (error: any) => {
            console.error("Error al guardar árbitro: ", error);
            this.error = error;
            this.isSaving = false;
            this.saveInFlight = null;
            reject(error); // Rechaza la promesa si hay un error
          }
        });
      } else {
        this.saveInFlight = null;
        reject('ID no proporcionado'); // Rechaza la promesa si no hay id
      }
    });
    return this.saveInFlight;
  };


  /**
   * Rellena los datos del formulario
   * @param arbitro Arbitro con todos los datos extraidos de la DB
   */
  rellenarDatos(arbitro: Arbitro): void {
    // Datos
    this.basicWizardForm.get('datos.nombre')?.setValue(arbitro.nombre);
    this.basicWizardForm.get('datos.apellidos')?.setValue(arbitro.apellidos);
    this.basicWizardForm.get('datos.genero')?.setValue(arbitro.genero);
    const fechaNacimiento = arbitro.fecha_nacimiento ? new Date(arbitro.fecha_nacimiento).toISOString().split('T')[0] : null;
    this.basicWizardForm.get('datos.fecha_nacimiento')?.setValue(fechaNacimiento);
    this.basicWizardForm.get('datos.titulo')?.setValue(arbitro.titulo);
    this.basicWizardForm.get('datos.institucion')?.setValue(arbitro.institucion);
    this.basicWizardForm.get('datos.cargo')?.setValue(arbitro.cargo);
    this.basicWizardForm.get('datos.direccion')?.setValue(arbitro.direccion);
    this.basicWizardForm.get('datos.telefono')?.setValue(arbitro.telefono);
    this.basicWizardForm.get('datos.movil')?.setValue(arbitro.movil);
    //this.basicWizardForm.get('datos.email')?.setValue(arbitro.email);
    if (arbitro.email) {
      this.emailControl.setValue(arbitro.email);
    }

    this.basicWizardForm.get('datos.es_representante')?.setValue(arbitro.es_representante);
    if (arbitro.es_representante === true)
      this.basicWizardForm.get('datos.es_representante')?.disable();


    this.basicWizardForm.get('datos.nacionalidades')?.setValue(arbitro.nacionalidades);
    this.nacionalidadesArray = arbitro.nacionalidades ?? [];

    this.basicWizardForm.get('datos.profesiones')?.setValue(arbitro.profesiones);
    this.profesionesArray = arbitro.profesiones ?? [];

    this.basicWizardForm.get('datos.profesion_otras')?.setValue(arbitro.profesion_otras);

    // Formacion
    this.basicWizardForm.get('formacion.titulos_academicos')?.setValue(arbitro.titulos_academicos);
    this.basicWizardForm.get('formacion.experiencia_profesional')?.setValue(arbitro.experiencia_profesional);

    this.basicWizardForm.get('formacion.colegiaciones')?.setValue(arbitro.colegiaciones);
    this.colegiacionesArray = arbitro.colegiaciones ?? [];

    this.basicWizardForm.get('formacion.idiomas')?.setValue(arbitro.idiomas); // Esto hace que el form tome valor !!!!!!
    this.idiomasArray = arbitro.idiomas ?? []; // Esto rellena el form para que se vea lo seleccionado !!!!!

    this.basicWizardForm.get('formacion.idiomas_otros')?.setValue(arbitro.idiomas_otros);
    this.basicWizardForm.get('formacion.sectores')?.setValue(arbitro.sectores);

    this.sectoresArray = arbitro.sectores ?? [];
    this.basicWizardForm.get('formacion.sectores_otros')?.setValue(arbitro.sectores_otros);

    // Experiencia
    this.basicWizardForm.get('experiencia.exp_internacional_ciam_presidente')?.setValue(arbitro.exp_internacional_ciam_presidente);
    this.basicWizardForm.get('experiencia.exp_internacional_otra_presidente')?.setValue(arbitro.exp_internacional_otra_presidente);
    this.basicWizardForm.get('experiencia.exp_internacional_adhoc_presidente')?.setValue(arbitro.exp_internacional_adhoc_presidente);
    this.basicWizardForm.get('experiencia.exp_nacional_institucional_presidente')?.setValue(arbitro.exp_nacional_institucional_presidente);
    this.basicWizardForm.get('experiencia.exp_nacional_adhoc_presidente')?.setValue(arbitro.exp_nacional_adhoc_presidente);
    this.basicWizardForm.get('experiencia.exp_internacional_ciam_arbitro_unico')?.setValue(arbitro.exp_internacional_ciam_arbitro_unico);
    this.basicWizardForm.get('experiencia.exp_internacional_otra_arbitro_unico')?.setValue(arbitro.exp_internacional_otra_arbitro_unico);
    this.basicWizardForm.get('experiencia.exp_internacional_adhoc_arbitro_unico')?.setValue(arbitro.exp_internacional_adhoc_arbitro_unico);
    this.basicWizardForm.get('experiencia.exp_nacional_institucional_arbitro_unico')?.setValue(arbitro.exp_nacional_institucional_arbitro_unico);
    this.basicWizardForm.get('experiencia.exp_nacional_adhoc_arbitro_unico')?.setValue(arbitro.exp_nacional_adhoc_arbitro_unico);
    this.basicWizardForm.get('experiencia.exp_internacional_ciam_coarbitro')?.setValue(arbitro.exp_internacional_ciam_coarbitro);
    this.basicWizardForm.get('experiencia.exp_internacional_otra_coarbitro')?.setValue(arbitro.exp_internacional_otra_coarbitro);
    this.basicWizardForm.get('experiencia.exp_internacional_adhoc_coarbitro')?.setValue(arbitro.exp_internacional_adhoc_coarbitro);
    this.basicWizardForm.get('experiencia.exp_nacional_institucional_coarbitro')?.setValue(arbitro.exp_nacional_institucional_coarbitro);
    this.basicWizardForm.get('experiencia.exp_nacional_adhoc_coarbitro')?.setValue(arbitro.exp_nacional_adhoc_coarbitro);
    this.basicWizardForm.get('experiencia.exp_internacional_ciam_letrado')?.setValue(arbitro.exp_internacional_ciam_letrado);
    this.basicWizardForm.get('experiencia.exp_internacional_otra_letrado')?.setValue(arbitro.exp_internacional_otra_letrado);
    this.basicWizardForm.get('experiencia.exp_internacional_adhoc_letrado')?.setValue(arbitro.exp_internacional_adhoc_letrado);
    this.basicWizardForm.get('experiencia.exp_nacional_institucional_letrado')?.setValue(arbitro.exp_nacional_institucional_letrado);
    this.basicWizardForm.get('experiencia.exp_nacional_adhoc_letrado')?.setValue(arbitro.exp_nacional_adhoc_letrado);
    this.basicWizardForm.get('experiencia.exp_internacional_ciam_secretario')?.setValue(arbitro.exp_internacional_ciam_secretario);
    this.basicWizardForm.get('experiencia.exp_internacional_otra_secretario')?.setValue(arbitro.exp_internacional_otra_secretario);
    this.basicWizardForm.get('experiencia.exp_internacional_adhoc_secretario')?.setValue(arbitro.exp_internacional_adhoc_secretario);
    this.basicWizardForm.get('experiencia.exp_nacional_institucional_secretario')?.setValue(arbitro.exp_nacional_institucional_secretario);
    this.basicWizardForm.get('experiencia.exp_nacional_adhoc_secretario')?.setValue(arbitro.exp_nacional_adhoc_secretario);
    this.basicWizardForm.get('experiencia.exp_internacional_ciam_arbitro_emergencia')?.setValue(arbitro.exp_internacional_ciam_arbitro_emergencia);
    this.basicWizardForm.get('experiencia.exp_internacional_otra_arbitro_emergencia')?.setValue(arbitro.exp_internacional_otra_arbitro_emergencia);
    this.basicWizardForm.get('experiencia.exp_internacional_adhoc_arbitro_emergencia')?.setValue(arbitro.exp_internacional_adhoc_arbitro_emergencia);
    this.basicWizardForm.get('experiencia.exp_nacional_institucional_arbitro_emergencia')?.setValue(arbitro.exp_nacional_institucional_arbitro_emergencia);
    this.basicWizardForm.get('experiencia.exp_nacional_adhoc_arbitro_emergencia')?.setValue(arbitro.exp_nacional_adhoc_arbitro_emergencia);
    this.basicWizardForm.get('experiencia.experiencia_cumplimentada')?.setValue(arbitro.experiencia_cumplimentada);

    this.basicWizardForm.get('experiencia.sistemasJuridicos')?.setValue(arbitro.sistemasJuridicos);
    this.sistemasJuridicosArray = arbitro.sistemasJuridicos ?? [];

    this.basicWizardForm.get('experiencia.sistema_juridico_otros')?.setValue(arbitro.sistema_juridico_otros);
    this.basicWizardForm.get('experiencia.comunicaciones_comerciales')?.setValue(arbitro.comunicaciones_comerciales);

    // Si soy admin, también tengo que devolver los comentarios internos
    if (this.adminView)
      this.basicWizardForm.get('comentarios.comentarios_internos')?.setValue(arbitro.comentarios_internos);
  }


  /**
   * Inicializa el formulario
   * 
   */
  initializeForm(): void {
    // initialize forms       
    this.basicWizardForm = this.fb.group({
      datos: this.fb.group({
        nombre: [''],
        apellidos: [''],
        genero: [''],
        fecha_nacimiento: [''],
        titulo: [''],
        institucion: [''],
        cargo: [''],
        direccion: [''],
        telefono: [''],
        movil: [''],
        //email: [''],
        nacionalidades: [[]],
        es_representante: [''],
        profesiones: [[]],
        profesion_otras: ['']
      }),
      formacion: this.fb.group({
        titulos_academicos: [''],
        experiencia_profesional: [''],
        colegiaciones: [[]],
        idiomas: [[]],
        idiomas_otros: [''],
        sectores: [[]],
        sectores_otros: [''],
      }),
      experiencia: this.fb.group({
        exp_internacional_ciam_presidente: ['', Validators.pattern(/^\d{0,4}$/)],
        exp_internacional_otra_presidente: [''],
        exp_internacional_adhoc_presidente: [''],
        exp_nacional_institucional_presidente: [''],
        exp_nacional_adhoc_presidente: [''],
        exp_internacional_ciam_arbitro_unico: [''],
        exp_internacional_otra_arbitro_unico: [''],
        exp_internacional_adhoc_arbitro_unico: [''],
        exp_nacional_institucional_arbitro_unico: [''],
        exp_nacional_adhoc_arbitro_unico: [''],
        exp_internacional_ciam_coarbitro: [''],
        exp_internacional_otra_coarbitro: [''],
        exp_internacional_adhoc_coarbitro: [''],
        exp_nacional_institucional_coarbitro: [''],
        exp_nacional_adhoc_coarbitro: [''],
        exp_internacional_ciam_letrado: [''],
        exp_internacional_otra_letrado: [''],
        exp_internacional_adhoc_letrado: [''],
        exp_nacional_institucional_letrado: [''],
        exp_nacional_adhoc_letrado: [''],
        exp_internacional_ciam_secretario: [''],
        exp_internacional_otra_secretario: [''],
        exp_internacional_adhoc_secretario: [''],
        exp_nacional_institucional_secretario: [''],
        exp_nacional_adhoc_secretario: [''],
        exp_internacional_ciam_arbitro_emergencia: [''],
        exp_internacional_otra_arbitro_emergencia: [''],
        exp_internacional_adhoc_arbitro_emergencia: [''],
        exp_nacional_institucional_arbitro_emergencia: [''],
        exp_nacional_adhoc_arbitro_emergencia: [''],
        experiencia_cumplimentada: [''],
        sistemasJuridicos: [[]],
        sistema_juridico_otros: [''],
        comunicaciones_comerciales: ['']
      }),
      comentarios: this.fb.group({
        comentarios_internos: ['']
      })
      //experiencia: [false, Validators.requiredTrue],

    });
  }

  /**
   * Recibe el árbitro y devuelve todos los totales de la experiencia
   * 
   */
  calcularTotalesFila(arbitro: Arbitro): void {

    // Presidente
    const presidentValues = [
      arbitro.exp_internacional_ciam_presidente,
      arbitro.exp_internacional_otra_presidente,
      arbitro.exp_internacional_adhoc_presidente,
      arbitro.exp_nacional_institucional_presidente,
      arbitro.exp_nacional_adhoc_presidente
    ].map(value => parseFloat(value ?? "0"));

    const arbitroUnicoValues = [
      arbitro.exp_internacional_ciam_arbitro_unico,
      arbitro.exp_internacional_otra_arbitro_unico,
      arbitro.exp_internacional_adhoc_arbitro_unico,
      arbitro.exp_nacional_institucional_arbitro_unico,
      arbitro.exp_nacional_adhoc_arbitro_unico
    ].map(value => parseFloat(value ?? "0"));

    // Obtener los valores de los campos que terminan en '_coarbitro' y convertirlos a números
    const coarbitroValues = [
      arbitro.exp_internacional_ciam_coarbitro,
      arbitro.exp_internacional_otra_coarbitro,
      arbitro.exp_internacional_adhoc_coarbitro,
      arbitro.exp_nacional_institucional_coarbitro,
      arbitro.exp_nacional_adhoc_coarbitro
    ].map(value => parseFloat(value ?? "0")); // Usar 0 como valor predeterminado si es undefined

    // Obtener los valores de los campos que terminan en '_letrado' y convertirlos a números
    const letradoValues = [
      arbitro.exp_internacional_ciam_letrado,
      arbitro.exp_internacional_otra_letrado,
      arbitro.exp_internacional_adhoc_letrado,
      arbitro.exp_nacional_institucional_letrado,
      arbitro.exp_nacional_adhoc_letrado
    ].map(value => parseFloat(value ?? "0")); // Usar 0 como valor predeterminado si es undefined

    // Obtener los valores de los campos que terminan en '_secretario' y convertirlos a números
    const secretarioValues = [
      arbitro.exp_internacional_ciam_secretario,
      arbitro.exp_internacional_otra_secretario,
      arbitro.exp_internacional_adhoc_secretario,
      arbitro.exp_nacional_institucional_secretario,
      arbitro.exp_nacional_adhoc_secretario
    ].map(value => parseFloat(value ?? "0")); // Usar 0 como valor predeterminado si es undefined

    // Obtener los valores de los campos que terminan en '_arbitro_emergencia' y convertirlos a números
    const arbitroEmergenciaValues = [
      arbitro.exp_internacional_ciam_arbitro_emergencia,
      arbitro.exp_internacional_otra_arbitro_emergencia,
      arbitro.exp_internacional_adhoc_arbitro_emergencia,
      arbitro.exp_nacional_institucional_arbitro_emergencia,
      arbitro.exp_nacional_adhoc_arbitro_emergencia
    ].map(value => parseFloat(value ?? "0")); // Usar 0 como valor predeterminado si es undefined


    // Sumar los valores
    const totalPresidentValues = presidentValues.reduce((total, value) => total + value, 0);
    const totalArbitroUnicoValues = arbitroUnicoValues.reduce((total, value) => total + value, 0);
    const totalCoarbitroValues = coarbitroValues.reduce((total, value) => total + value, 0);
    const totalLetradoValues = letradoValues.reduce((total, value) => total + value, 0);
    const totalSecretarioValues = secretarioValues.reduce((total, value) => total + value, 0);
    const totalArbitroEmergenciaValues = arbitroEmergenciaValues.reduce((total, value) => total + value, 0);

    this.totalesFila = [
      { label: "presidente", value: totalPresidentValues },
      { label: "arbitro_unico", value: totalArbitroUnicoValues },
      { label: "coarbitro", value: totalCoarbitroValues },
      { label: "letrado", value: totalLetradoValues },
      { label: "secretario", value: totalSecretarioValues },
      { label: "arbitro_emergencia", value: totalArbitroEmergenciaValues }
    ];

  }

  /**
     * Recibe el árbitro y devuelve todos los totales de la experiencia
     * 
     */
  calcularTotalesColumna(arbitro: Arbitro): void {

    // Sumar los valores para cada agrupación
    const totalCiamValues = [
      arbitro.exp_internacional_ciam_presidente,
      arbitro.exp_internacional_ciam_arbitro_unico,
      arbitro.exp_internacional_ciam_coarbitro,
      arbitro.exp_internacional_ciam_letrado,
      arbitro.exp_internacional_ciam_secretario,
      arbitro.exp_internacional_ciam_arbitro_emergencia
    ].map(value => parseFloat(value ?? "0")).reduce((total, value) => total + value, 0);

    const totalOtraValues = [
      arbitro.exp_internacional_otra_presidente,
      arbitro.exp_internacional_otra_arbitro_unico,
      arbitro.exp_internacional_otra_coarbitro,
      arbitro.exp_internacional_otra_letrado,
      arbitro.exp_internacional_otra_secretario,
      arbitro.exp_internacional_otra_arbitro_emergencia
    ].map(value => parseFloat(value ?? "0")).reduce((total, value) => total + value, 0);

    const totalAdhocValues = [
      arbitro.exp_internacional_adhoc_presidente,
      arbitro.exp_internacional_adhoc_arbitro_unico,
      arbitro.exp_internacional_adhoc_coarbitro,
      arbitro.exp_internacional_adhoc_letrado,
      arbitro.exp_internacional_adhoc_secretario,
      arbitro.exp_internacional_adhoc_arbitro_emergencia
    ].map(value => parseFloat(value ?? "0")).reduce((total, value) => total + value, 0);

    const totalInstitucionalValues = [
      arbitro.exp_nacional_institucional_presidente,
      arbitro.exp_nacional_institucional_arbitro_unico,
      arbitro.exp_nacional_institucional_coarbitro,
      arbitro.exp_nacional_institucional_letrado,
      arbitro.exp_nacional_institucional_secretario,
      arbitro.exp_nacional_institucional_arbitro_emergencia
    ].map(value => parseFloat(value ?? "0")).reduce((total, value) => total + value, 0);

    const totalAdhocNacionalValues = [
      arbitro.exp_nacional_adhoc_presidente,
      arbitro.exp_nacional_adhoc_arbitro_unico,
      arbitro.exp_nacional_adhoc_coarbitro,
      arbitro.exp_nacional_adhoc_letrado,
      arbitro.exp_nacional_adhoc_secretario,
      arbitro.exp_nacional_adhoc_arbitro_emergencia
    ].map(value => parseFloat(value ?? "0")).reduce((total, value) => total + value, 0);

    this.totalesColumna = [
      { label: "ciam", value: totalCiamValues },
      { label: "otra", value: totalOtraValues },
      { label: "internacional_adhoc", value: totalAdhocValues },
      { label: "institucional", value: totalInstitucionalValues },
      { label: "nacional_adhoc", value: totalAdhocNacionalValues }
    ];
  }



  /**
   * Recibe un array de {label, value} y devuelve el value del label
   * 
   */
  getTotal(datos: { label: string, value: number }[], label: string): number {
    const item = datos.find(item => item.label === label);
    return item ? item.value : 0; // Si se encuentra el objeto, devuelve su valor; de lo contrario, devuelve 0.
  }

  // Manejo de la navegación del wizard
  goToPreviousStep() {
    if (this.activeWizard1 > 1) {
      this.activeWizard1 -= 1;
      this.reloadData();
    }
  }

  goToNextStep() {
    if (this.activeWizard1 < this.maxtab) {
      this.activeWizard1 += 1;
      this.reloadData();
    }
  }

  finalSave() {
    this.finalSaveMessage = true;
    this.reloadData();
  }

  // Guarda el formulario y carga de nuevo los datos
  async reloadData() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      if (this.saveInFlight) {
        await this.saveInFlight;
        return;
      }
      if (!this.hasUnsavedChanges()) {
        return;
      }
      clearTimeout(this.saveTimer);
      try {
        await this.guardarDatosDelayed(id);
        this._fetchData(id);
      } catch (error) {
        console.error("Error en reloadData: ", error);
      }
    }
  }

  // Para cambiar de pestaña en el formulario y guardar datos al mismo estilo que lo hace el botón de siguiente y anterior
  onNavChange($event: NgbNavChangeEvent) {
    //console.log('Cambiando a la pestaña:', $event.nextId);
    this.reloadData();
    //this.mostrarMensajeGuardado()
  }

  hasUnsavedChanges(): boolean {
    return this.lastSavedFormValue !== JSON.stringify(this.basicWizardForm.value);
  }

  uploadAvatar(id: string, avatar: File) {
    if (id) {
      //this.isSaving = true;      
      const formData = new FormData();
      formData.append('foto', avatar);

      /*
      //Para ver la foto en consola
      for (var pair of (formData as any).entries()) {
        console.log(pair[0] + ': ', pair[1]);
        if (pair[1] instanceof File) {
            console.log(`File name: ${pair[1].name}, File size: ${pair[1].size} bytes`);
        }
    }
    */

      this.arbitrosService.updateAvatar(id, formData).subscribe({
        next: () => {
          this.mostrarMensajeGuardado()
          this.error = '';
          this.reloadData();
          //console.log("Avatar enviado al back->", formData);
          // Después de guardar, emitir el evento para actualizar el avatar
          this.eventService.broadcast(EventType.UPDATE_AVATAR, { userId: id });
        },
        error: (error: any) => {
          //console.error("Error al guardar árbitro: ", error, id, formData);
          this.error = error;
          //this.isSaving = false;
        }
      });
    }
  }

  // Se ejecuta cuando hace el value Change en el input de la foto
  onFileChange(event: Event) {

    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        const avatar = input.files[0];
        if (this.avatarObjectUrl) {
          URL.revokeObjectURL(this.avatarObjectUrl);
        }
        this.avatarObjectUrl = URL.createObjectURL(avatar);
        this.avatarUrl = this.sanitizer.bypassSecurityTrustUrl(this.avatarObjectUrl);
        this.uploadAvatar(id, avatar);
      }
    }

  }

  // Se llama desde el botón para cambiar foto
  triggerFileInput() {
    // Accede al elemento input usando document.getElementById y dispara el clic
    const fileInput = document.getElementById('inputAvatar') as HTMLInputElement;
    fileInput.click();
  }

  mostrarMensajeGuardado() {
    this.isSaving = true;
    setTimeout(() => {
      this.isSaving = false;
    }, 2000); // Retardo de 2 segundos también en caso de error
  }

  triggerCambiarEmail(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      // Obtener el valor del email desde el FormControl independiente
      const updatedEmail = this.emailControl.value;

      // Crear un objeto Arbitro usando los datos actuales del formulario
      const arbitro: Arbitro = {
        email: updatedEmail, // Asigna el valor del email
        // Añade otros campos según sea necesario
      };

      // Llamar a updateArbitro para guardar los cambios
      this.arbitrosService.updateArbitro(id, arbitro).subscribe({
        next: () => {
          this.mostrarMensajeGuardado();
          this.error = '';
          const triggerCambiarEmailCasoSuccessMessage: string = $localize`:@@triggerCambiarEmailCasoSuccessMessage:Email enviado al usuario para confirmar cambio`;
          this.notificationService.showSuccessNotification(triggerCambiarEmailCasoSuccessMessage)
          this.reloadData(); // Recargar datos después de guardar
        },
        error: (error: any) => {
          console.error("Error al guardar email: ", error);
          this.error = error;
        }
      });
    }
  }



}
